<div class="panel-list-root">
    <as-split
                    unit="percent"
                    direction="horizontal"
                    gutterAriaLabel="adjustable divider between two views"
                    #split="asSplit" (dragEnd)="dragEnd($event)">
                
        <as-split-area [size]="sizeLeft" #area1="asSplitArea">
            <div class="panel-list" >
                <div class="panel-list-item" *ngFor="let step of steps; let index = index" (click)="selectTabName(index)" [class.active]="selectedIndex === index">
                    <div  [ngClass]="selectedIndex === index?'item-selected':'none'" [@tabMovement]="{value:typeSelection, params:{offset:multiplyer}}"></div>
                    <div>{{step.label|translateTA}}</div>
                </div>
            </div>    
        </as-split-area>
        <as-split-area [size]="sizeRight"  #area2="asSplitArea">
            <div *ngIf="selected" class="panel-list-item-wrapper-body" [style.display]="selected ? 'flex' : 'none'" [@slideInOut]="{ params:{offset:multiplyerBody}}" >
                <div  id="tab1" class="panel-list-item-body mat-elevation-z3">
                    <div class="title-panel">
                        {{selected.title|translateTA}}
                    </div>
                    <mat-divider></mat-divider>
                    <div class="info mat-elevation-z3" *ngIf="selected.info!=null">
                        {{selected.info|translateTA}}
                    </div>
                    <mat-divider></mat-divider>
                    <ng-container
                            [ngTemplateOutlet]="selected ? selected.content : null">
                    </ng-container>
                </div>
            </div>
        </as-split-area>
    </as-split>    
</div>
    
    
    
    
    
    